module.exports = __webpack_public_path__ + "static/media/lending-tools5.e49f147c.svg";